module.exports = __webpack_public_path__ + "static/manshour-complete-7f9267f363747546de22c3a8e5bc02ad.jpg";